import OnboardingType from './onboardingType'
import BvnVerification from './bvnVerification'
import PhoneNumberVerification from './phoneNumberVerification'
import UserVerification from './userVerification'
import InfoConfirmation from './infoConfirmation'
import IdentityVerification from './identityVerification'
import CredentialsCreation from './credentialsCreation'
import SecurityQuestions from './securityQuestions'
import Referral from './referral'
import ProfileCompletion from './profileCompletion'

export default [
    OnboardingType,
    BvnVerification,
    PhoneNumberVerification,
    UserVerification,
    InfoConfirmation,
    IdentityVerification,
    CredentialsCreation,
    SecurityQuestions,
    Referral,
    ProfileCompletion
]